import {
    apiGateway
} from '../api'

// Tipos de Operação: InclusaoTitular, InclusaoDependente, AlteracaoCadastral, 
// TransferenciaDeContrato, TrocaDePlano, Reativacao, Exclusao, CancelaExclusao, AposentadosDemitidos
// Formato dataNascimento: 1986-05-01
async function buscaDocumentosPorContrato(numContrato, tipoOperacao, dataNascimento, codigoDependencia) {
    try {
        const params = new URLSearchParams();
        params.append("tipoOperacao", tipoOperacao);
        params.append("dataNascimento", dataNascimento);
        if (codigoDependencia) params.append("codigoDependencia", codigoDependencia);

        const response = await apiGateway.get(`/documentos/tipoMovimentacao/numeroContrato/${  numContrato}`, {
            params
        });
        return response.data;
    } catch (error) {
        return false;
    }
}

export {
    buscaDocumentosPorContrato
}